/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import {  } from "relay-runtime";
export type PdpSharedShippingInfo_shipment = {
    readonly shippingAddress: {
        readonly displayCityStateCountry: string | null;
    } | null;
    readonly " $refType": "PdpSharedShippingInfo_shipment";
};
export type PdpSharedShippingInfo_shipment$data = PdpSharedShippingInfo_shipment;
export type PdpSharedShippingInfo_shipment$key = {
    readonly " $data"?: PdpSharedShippingInfo_shipment$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"PdpSharedShippingInfo_shipment">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedShippingInfo_shipment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "Address",
      "kind": "LinkedField",
      "name": "shippingAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "displayCityStateCountry",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Shipment",
  "abstractKey": null
};
(node as any).hash = '63a4966ec5582ed4c6b378bf5597921b';
export default node;
